import { render } from "./ProductRecommendations.vue?vue&type=template&id=1fd0cb99"
import script from "./ProductRecommendations.vue?vue&type=script&lang=js"
export * from "./ProductRecommendations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__